var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-container',[_c('b-row',{staticClass:"vh-100 text-center",attrs:{"align-v":"center"}},[_c('b-col'),_c('b-col',[_c('CreateWall',{attrs:{"msg":"Everscale Walls"}})],1),_c('b-col')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }